import { Link } from 'react-router-dom';
import { trendingArticles } from '@/mocks/articles';

export default function HotGrid() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              <strong>全网热门追踪</strong>
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              最新最热的爆料内容，实时更新中
            </p>
          </div>
          <Link
            to="/category/wanghong-heiliao"
            className="text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {trendingArticles.slice(0, 8).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`911爆料网 - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Heat Badge */}
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {article.heat > 9999
                      ? `${(article.heat / 10000).toFixed(1)}万热度`
                      : `${article.heat}热度`}
                  </span>
                </div>
                {/* Category Tag */}
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-background-50/90 text-foreground-700 text-xs rounded-md whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs mt-2 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/60">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}